import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { type OpenableControls } from '../../../../../generic-hooks'

export const RxNowSaveModal: FC<{
  modalControls: OpenableControls
}> = ({ modalControls }) => {
  return (
    <Dialog onClose={modalControls.handleClose} open={modalControls.isOpen}>
      <DialogTitle onClose={modalControls.handleClose}>
        <FormattedMessage id="rx.ch.now.save.modal.header" />
      </DialogTitle>
      <DialogContent>
        <span className="prose bg-light-primary-medium">
          <h3 className="mt-0">
            <FormattedMessage id="rx.ch.now.save.modal.content.heading" />
          </h3>
          <p>
            <FormattedMessage id="rx.ch.now.save.modal.content.body" />
          </p>
        </span>
      </DialogContent>
    </Dialog>
  )
}
